<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>媒体专访</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="scientist_main">
            <p class="scie_title">科学家成“网红”需要正确打开方式</p>

            <p class="con_p">
                最近，著名理论物理学家史蒂芬·霍金开通了微博并一跃成为新晋“网红”，引发了中国网友们的关注，截至目前，已经轻轻松松圈粉300多万。
                “感觉智商被拉高的”网友们纷纷表示，以后物理题不会做可以直接问霍金老师了。互联网的交流方式打破了人们以往通过官方报道了解名人的方式，
                实际上，“霍老师”成为网红早有潜质，之前参加乐队的表演、在知名美剧《生活大爆炸》中的出境都有出色表现，每次的本色出演几乎都能引发人们对科学的关注，
                而霍金最近发布的一条微博也让他的纳米飞行器从一个高深命题成为迅速被围观的普通话题。也有网友表示，“原来霍老师在用生命做‘科普’啊。” 科普，
                一个一直以来熟悉的字眼，但透过霍金的个案，我们能否看到公众科学思想上的问题？能否关注到我们在培养科学意识上还尚存缺憾？
                意识到在成就未来科学发现的道路上还有漫长的道路？感受到“民科”与科学家们的“对弈”当中透露的隐忧？在科学观的建立中找到最正确的打开方式…… 
                国内专家不接地气？科学家说话要“翻译”？                                                                         
            </p>
                <img src="../../../assets/images/1.png" alt="">
                <P class="con_p">
                    曾任教于牛津大学、加州大学伯克利分校的中国科学院“百人计划”教授、中国载人空间站天空（X-1)号货运飞船冷原子平台首席科学家、北京大学教
                    授马兆远回忆自己在牛津任教时候的经历，“每周五下午，牛津物理系都要举办一个论坛，四五百人的报告厅座无虚席。” 论坛的对象是“所有人”，每个愿
                    意来听的普通人都可以走进这间报告厅。在互联网上，牛津、哈佛的公开课也是网络上最火爆的视频资源，在国内也有着大量的听众，科学普及工作可以说是自然而然的。而在国
                    内的某些科学论坛和发布会，主办方却要提前做好身份核实，担心“民科”入场，对于一些过于要求结论的问题，科学家也很难回答，这也让不少科学家开始
                    对这种场合有所忧虑，逐渐放弃了一些与公众沟通的机会。事实上，公众和科学家之间的距离远不止于此，在网上也经常有对“专家 ”的调侃。
                    认为专家讲话“听不懂”，不接地气。认为很多话“说了等于没说”，听了也没结论。 
                </P>
            <p class="con_p">
                 在记者访问一些科学家的时候，一些科学家也表示过苦恼，因为很多问题“没必要”回答，认为一些问题“不是问题”，而有科学家也表示过，
                 这样的问题一旦被“道德绑架”，科学家就成了“不负责任的人”，成了“冰冷”的科学怪咖。在马兆远看来，这种距离的逐渐减小，
                 是一个需要两边向中间走的过程，需要科学家和公众共同努力。科学家在发表言论的时候，应该保证对话题的“透彻的了解”。
                 而大多数的科学家虽然接受过多年的科学研究训练，却没有“将科学术语翻译成公众能理解语言”的能力，这也是问题之一。 
                 <span style="font-weight: 700;margin-left: 10px; margin-right: 10px;">民众基础或许更重要陈景润、牛顿有“坏”影响</span> 矛盾恰恰反映了科学意识在国内的构建问题。马兆远告诉记者，良好的互动根本上是需要以民众基础为前提的。
                 而在漫长的中国历史上，中国人是与西方的科学启蒙有距离的。直到上个世纪初期的时候，中国人才有了被科学启蒙的机会，同时，在那个时期，
                 中国也建立了现代大学。
            </p>

            <p class="con_p">
                 在这期间，我们培养了一批科学家。马兆远以北大物理系为例，后来长期担任北京大学物理系主任的饶毓泰于20世纪20年代在普林斯顿大学完成博士学业，
                 而量子力学就是在此期间成型的，饶毓泰的导师则是量子力学早期的奠基人之一。饶毓泰回国后培养了吴大猷等人，而杨振宁、李政道则出于这些人的门下，
                 马兆远说：“中国人真实参与了那个时期国际科学界的研究，这也是中国历史上第一个这样的时期。可以说，当时中国的科学是不落后于世界的。” 
                 但经历了战火动荡的中国，在生产力和工业基础遭到破坏的环境里，我们与国外科学圈子隔离了。
            </p>

            <p class="con_p">
                马兆远说，实际上，陈景润等人的成功也影响了很多人，这种导向如今来说可能是“弊大于利”，这让很多国人都认为科学是可以通过“关上门在家里做研究”
                来实现的，是任何人都能做的。马兆远说：“从科学的角度看，数学理论在一定程度上是可以这样进行的，但是现代科学还是需要实证主义的，
                科学是不可关起门发展的。” 很多家长都将“牛顿与苹果”的故事，作为给孩子早期的科学启蒙案例之一，在马兆远看来，这反映了很多人对科学生发的误解，
                认为“ 思考”就能解决科学问题。20世纪初，科学开始依靠大量的实验为基础，随着工业的发展，科学成了建立在不断试验基础上的一件事情，
                 “而不是在家里靠几个试管就搞出来的成就”。牛顿在苹果树下的领悟，在科学发展史上可以说是没有过的，马兆远说：“牛顿的发展是依托科学200年的发展。” 
            </p>
                <img src="../../../assets/images/2.png" alt="">
                <p class="con_p">
                <span style="font-weight: 700; margin-right: 10px;">科学家解决不了“宇宙真理”</span>   现代科学依靠实证主义“民科”生发的思想根源就在于对“个人科学主义”的放大，群体也基本上是一些并没有受过系统科学训
                练的人去思考一些大得吓人的问题。实际上，几个人共同考虑一些“大问题”是科学史上出现过的模式，但是，对于 近代科学来说，科学家个人都是要通过
                探索实验去完成分工下的“小问题”，这也就解释了为何少有科学家愿意直接面对“民科”。因为，两方根本不在一个“频道”上。那么，这种思考“大
                问题”与“小问题”之间的区别在哪儿呢？马兆远介绍，在漫长的人类历史时期，人们都在幻想中生存，古代人类去尝试寻找事物之间的相关性，但是思路
                并非那么准确和具体，人们很难了解某些联系之间有怎样的规律，比如人们会为了求雨展开祭祀活动。直到近代的欧洲，人们才通过实证主义，通过不断筛
                选案例、想法，得到一种规律方案。但是，这种方案并非是结论和真理。在我们的普遍意识中，“真理”看似是一种绝对答案，真理也就等于科学。
                但是在科学家眼中，“真理”或许只是一种状态，科学不是结果，也不存在终极结论，它更应当是方法论，也就是说：“科学也许并非真理。” 
                马兆远说：“20世纪以后，科学和真理这两个概念已经渐行渐远，科学家们不再将科学解释为寻找真理的过程，而只是认为自己在不断拓 
                宽人类认识宇宙的边界，而那道边界也许并不存在。”一些“民科”认为自己找到了“宇宙真理”，这对于受过科学训练的科学家来说，是荒谬的说法。
                本版撰文回振岩</p> 
            <p class="con_p"><span style="font-weight: 700; margin-right: 10px;">科学观应重视“发现” 远离答案去找金子</span>   树立科学观对于任何国家和民族都十分重要的话题，对于孩子和青年人来讲，更是尤其重要。
            但是一些发展中沉淀的经验思维，却暴露了我们在建立科学观时的一些盲点。在马兆远看来，对比西方，国人应当对“科学发现”有更多的认识和培养。
            他解释说，“中国的科学水平之高在世界上有目共睹，但是，我们很多时候还带有从德国借鉴的工程化思维，也就是说，我们的科学研究往往先确定目标，
            然后根据目标实现，这过程本身就类似一件工程的完工。”而这种先预设“答案”的思维模式，在科学观的建立中可能会对“科学发现”的地位有 所影响。 
            </p>


            <p class="con_p">
                马兆远认为，科学方法本身是告诉人们在没有目标的情况下如何系统地找到有价值的内容，这就要求从科学教育最初的时候，“答案”就不被认为是最重要的。
                他说：“就像没有人知道未来哪儿会有金子，但是科学方法就是教你如何最快找到金子，即便找不到，但也会找到更有价值的东西。”科学发现没有界定“真理”，
                科学只是一套方法，强调“实用性”能培养出更多的工程师，多快好省地实现目标，却更有价值的东西。”科学发现没有界定“真理”，科学只是一套方法，
                强调“实用性”能培养出更多的工程师，多快好省地实现目标，却很难培养出霍金这样的科学家。 
            </p>

            <p class="con_p" style="margin-top: 10px; margin-bottom: 10px; font-weight: 700">
                请别把霍金当“神”包装 
            </p>
            <p class="con_p">
                互联网部分取消了信息的不对等，这使得人们能看到一个更加真实点儿的霍金，看来，这是一件何其重要的事情。科学家是什么？他们不能发现宇宙的真理，
                也不能解决人类的一切问题。对于这类问题，古人依靠“神”的哲学和故事来加以解释，这种逻辑不需要实证。现代 科学教人类如何在发现上不再盲目探索，
                这种方法也使得科学发现成为一个不断试错的过程。如果我们还处于包装“神”的模式里，崇拜 着“学术英雄”，建立一个一个科学家“雕塑”，
                无疑是一件有悖于科学思维的事情，在霍金带给大家“宇宙热”的同时，更好地了解一些验证基本科学问题的方法，或许是一种理性的思考。 
            </p>

            <div class="scie_foot">
                <p class="con_p" style="margin-left: 28px;">
                    责任编辑：王晓易
                </p>
                <p class="con_p">
                    来源: 每日新报(天津)
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 


/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}

.scientist_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    /* height: 2700px; */
    overflow: hidden;
    margin-bottom: 60px;
}
.scientist_main .scie_title {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 73px;
}
.scientist_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    font-family: "Microsoft YaHei" ;
}
.scientist_main img {
    margin-left: 285px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.scie_foot {
    float: right;
    margin-top: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/news/scientist/scientist.vue